import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  inject,
  input,
  output,
  ChangeDetectionStrategy
} from '@angular/core';

import { CookiePreference } from '@ui/shared/model';

import { TranslatePipe } from '@ngx-translate/core';
import { fadeOnEnterLeaveAnimation } from '../../../utils/animations';
import { INFRASTRUCTURE_CONFIG } from '../../../infrastructure/infrastructure-config.token';

@Component({
  animations: [fadeOnEnterLeaveAnimation],
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ImmomioButtonComponent, TranslatePipe]
})
export class CookieBannerComponent {
  private config = inject(INFRASTRUCTURE_CONFIG);

  public get showCookieBanner() {
    const cookiePreference = this.cookiePreference();
    return (
      !cookiePreference ||
      (new Date().getTime() - cookiePreference?.lastUpdated) / 1000 >
        this.ONE_YEAR_IN_SEC
    );
  }

  private get isTenantApp() {
    return this.config.environment.app_name === 'tenant';
  }

  public get isMobile() {
    return this.config?.environment?.mobile;
  }

  readonly cookiePreference = input<CookiePreference>(undefined);
  readonly acceptAll = output<CookiePreference>();
  readonly customSettings = output<CookiePreference>();

  private ONE_YEAR_IN_SEC = 31557600;

  private DEFAULT_PREFERENCE = {
    allowRequired: true,
    allowPerformance: false,
    allowFunctional: false,
    lastUpdated: new Date().getTime()
  };

  onAcceptAll() {
    this.acceptAll.emit({
      allowRequired: true,
      allowPerformance: true,
      allowFunctional: true,
      lastUpdated: new Date().getTime()
    });
  }

  onCustomSettings() {
    this.customSettings.emit(
      this.cookiePreference() || this.DEFAULT_PREFERENCE
    );
  }

  dataPrivacyRedirect() {
    const url = this.isTenantApp
      ? 'https://www.immomio.com/datenschutz-mietinteressenten/'
      : 'https://www.vermieter.immomio.com/datenschutz';
    window.open(url, '_blank');
  }
}
